var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
import { jsx as _jsx } from "react/jsx-runtime";
import { useMachine } from '@xstate/react';
import { appointmentStatus, noteType } from 'constants/ehrNoteEnums';
import { defaultBaseEHRNote, noteSchema, noteSchemaInstanceMap, getSchemaDefaultValues, } from 'constants/note-schemas';
import { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { assign, createMachine } from 'xstate';
export var noteSchemaContext = createContext({});
export var noteSchemaTransitions;
(function (noteSchemaTransitions) {
    noteSchemaTransitions["attended"] = "ATTENDED";
    noteSchemaTransitions["notAttended"] = "NOT_ATTENDED";
    noteSchemaTransitions["lateCancel"] = "LATE_CANCEL";
    noteSchemaTransitions["intake"] = "INTAKE";
    noteSchemaTransitions["followUp"] = "FOLLOW_UP";
    noteSchemaTransitions["couplesFamilyTherapyIntake"] = "COUPLES_FAMILY_INTAKE";
    noteSchemaTransitions["couplesFamilyTherapyFollowUp"] = "COUPLES_FAMILY_FOLLOW_UP";
    noteSchemaTransitions["minorTherapyIntake"] = "MINOR_INTAKE";
    noteSchemaTransitions["minorTherapyFollowUp"] = "MINOR_FOLLOW_UP";
    noteSchemaTransitions["providerUnscheduled"] = "PROVIDER_UNSCHEDULED";
    noteSchemaTransitions["careNavigatorUnscheduled"] = "CARE_NAVIGATOR_UNSCHEDULED";
    noteSchemaTransitions["careNavigatorInitial"] = "CARE_NAVIGATOR_INITIAL";
    noteSchemaTransitions["careNavigatorFollowUp"] = "CARE_NAVIGATOR_FOLLOW_UP";
    noteSchemaTransitions["adultMedManagementIntake"] = "ADULT_MED_MANAGEMENT_INTAKE";
    noteSchemaTransitions["adultMedManagementFollowUp"] = "ADULT_MED_MANAGEMENT_FOLLOW_UP";
    noteSchemaTransitions["minorMedManagementIntake"] = "MINOR_MED_MANAGEMENT_INTAKE";
    noteSchemaTransitions["minorMedManagementFollowUp"] = "MINOR_MED_MANAGEMENT_FOLLOW_UP";
    noteSchemaTransitions["medManagerUnscheduled"] = "MED_MANAGER_UNSCHEDULED";
})(noteSchemaTransitions || (noteSchemaTransitions = {}));
export var noteSchemaTransitionsByNoteType = (_a = {},
    _a[noteType.adultTherapyFollowUp] = noteSchemaTransitions.followUp,
    _a[noteType.adultTherapyIntake] = noteSchemaTransitions.intake,
    _a[noteType.couplesFamilyTherapyIntake] = noteSchemaTransitions.couplesFamilyTherapyIntake,
    _a[noteType.couplesFamilyTherapyFollowUp] = noteSchemaTransitions.couplesFamilyTherapyFollowUp,
    _a[noteType.minorTherapyIntake] = noteSchemaTransitions.minorTherapyIntake,
    _a[noteType.minorTherapyFollowUp] = noteSchemaTransitions.minorTherapyFollowUp,
    _a[noteType.providerUnscheduled] = noteSchemaTransitions.providerUnscheduled,
    _a[noteType.careNavigatorUnscheduled] = noteSchemaTransitions.careNavigatorUnscheduled,
    _a[noteType.careNavigatorInitial] = noteSchemaTransitions.careNavigatorInitial,
    _a[noteType.careNavigatorFollowUp] = noteSchemaTransitions.careNavigatorFollowUp,
    _a[noteType.adultMedManagementIntake] = noteSchemaTransitions.adultMedManagementIntake,
    _a[noteType.adultMedManagementFollowUp] = noteSchemaTransitions.adultMedManagementFollowUp,
    _a[noteType.minorMedManagementIntake] = noteSchemaTransitions.minorMedManagementIntake,
    _a[noteType.minorMedManagementFollowUp] = noteSchemaTransitions.minorMedManagementFollowUp,
    _a[noteType.medManagerUnscheduled] = noteSchemaTransitions.medManagerUnscheduled,
    _a);
export var noteSchemaTransitionsByAppointmentStatus = (_b = {},
    _b[appointmentStatus.notAttended] = noteSchemaTransitions.notAttended,
    _b[appointmentStatus.lateCancel] = noteSchemaTransitions.lateCancel,
    _b[appointmentStatus.completed] = noteSchemaTransitions.attended,
    _b);
export var defaultNoteSchemasByNoteType = (_c = {},
    _c[noteType.adultTherapyFollowUp] = noteSchema.followUp,
    _c[noteType.adultTherapyIntake] = noteSchema.intake,
    _c[noteType.couplesFamilyTherapyIntake] = noteSchema.couplesFamilyTherapyIntake,
    _c[noteType.couplesFamilyTherapyFollowUp] = noteSchema.couplesFamilyTherapyFollowUp,
    _c[noteType.minorTherapyIntake] = noteSchema.minorTherapyIntake,
    _c[noteType.minorTherapyFollowUp] = noteSchema.minorTherapyFollowUp,
    _c[noteType.providerUnscheduled] = noteSchema.providerUnscheduled,
    _c[noteType.careNavigatorUnscheduled] = noteSchema.careNavigatorUnscheduled,
    _c[noteType.careNavigatorInitial] = noteSchema.careNavigatorInitial,
    _c[noteType.careNavigatorFollowUp] = noteSchema.careNavigatorFollowUp,
    _c[noteType.adultMedManagementIntake] = noteSchema.adultMedManagementIntake,
    _c[noteType.adultMedManagementFollowUp] = noteSchema.adultMedManagementFollowUp,
    _c[noteType.minorMedManagementIntake] = noteSchema.minorMedManagementIntake,
    _c[noteType.minorMedManagementFollowUp] = noteSchema.minorMedManagementFollowUp,
    _c[noteType.medManagerUnscheduled] = noteSchema.medManagerUnscheduled,
    _c);
export var NoteSchemaProvider = function (_a) {
    var _b, _c;
    var children = _a.children, _d = _a.initialState, initialState = _d === void 0 ? 'show' : _d, _e = _a.initialSchema, initialSchema = _e === void 0 ? null : _e, initialNoteType = _a.initialNoteType;
    var baseForm = useForm({
        defaultValues: __assign(__assign({}, defaultBaseEHRNote), { sessionInfo: __assign(__assign({}, defaultBaseEHRNote.sessionInfo), { noteType: initialNoteType }) }),
    });
    var ehrForm = useForm({
        defaultValues: getSchemaDefaultValues(noteSchemaInstanceMap[noteSchema.intake]),
    });
    var notAttendedForm = useForm({
        defaultValues: getSchemaDefaultValues(noteSchemaInstanceMap[noteSchema.notAttended]),
    });
    var lateCancelForm = useForm({
        defaultValues: getSchemaDefaultValues(noteSchemaInstanceMap[noteSchema.lateCancel]),
    });
    var unscheduledInteractionForm = useForm({
        defaultValues: getSchemaDefaultValues(noteSchemaInstanceMap[noteSchema.providerUnscheduled]),
    });
    var unscheduledCnInteractionForm = useForm({
        defaultValues: getSchemaDefaultValues(noteSchemaInstanceMap[noteSchema.careNavigatorUnscheduled]),
    });
    var cnAppointmentForm = useForm({
        defaultValues: getSchemaDefaultValues(noteSchemaInstanceMap[noteSchema.careNavigatorInitial]),
    });
    var mmForm = useForm({
        defaultValues: getSchemaDefaultValues(noteSchemaInstanceMap[noteSchema.adultMedManagementIntake]),
    });
    var unscheduledMMInteractionForm = useForm({
        defaultValues: getSchemaDefaultValues(noteSchemaInstanceMap[noteSchema.medManagerUnscheduled]),
    });
    var _f = useState({
        schema: null,
        form: baseForm,
    }), formSet = _f[0], setFormSet = _f[1];
    var machine = useRef(
    /** @xstate-layout N4IgpgJg5mDOIC5QDsD2AXMAVAngBzgDo0BlAC1QHcBiAQSywFEA5AEUdcVD1VgEt0fVMi4gAHogCMABkkAWQgDYAzAE5VAJk1yArIoAcAdlUAaEDkRaNhZfMk6dh6YcWLJ8gL4ezaTLgKwxKjkVNTMAPJYAPr0TGwcojz8gsKiEgju0vqEhsrKLnIaGgZuZhYIOtKqOZLKGnKqylX6cpIaXj4Y2PhEpBQ0ADL0jFEAwrTMo4wDibwCQiJI4lIy2bn5ioXF+qXmiIZya7UaDoqGkvruqh0gvt0BhLD9hACuyADWaJTI1LPJC2lEDotDYVLY3PpHHJFDoylJ9NlbK1Cqp9PlJKoXDc7v4iE9QhForEWOxOEskvNUkt0jJDNZFBomsY5Fl6tJlHCEBosoQqnT9EVcnJlK1sV1cYF8YNhmMJlMZuS5ilFqB0udqhoZOplHpDq5FJyGopCOp1BCNJdDDprt5buKepL+tQAJLMLC0ADSjD+lJVywQbkkSkU0m5eWOOlshtUxtNMYuFskVp2Yr8DseToAYuEBgNwgB1KIAVQACj7lYCModCMLnEV9Kp7K5ipz6sb0dIsu46Wb9Kn7nBqCRGNFCSMsABNEvexX-KmqxAqBSXFl0-LcnucmRKSPqKoqSE6Qr9iVDkdRMdREijAASjAAsrRywDqYgWcvKpIGZHMnI5FvpB3NRVH3ZRD2PMUIDgUQcXTPoqCCdBaHQTBkCgiBn3nf02hcQhGXyPQNAONQXENEMajqE5UWKexlBPODgmeAAbABDTBRhY5AAGMwCYzC-RpGicn0aQVBw4VMQNPYA3qGwEWBECRVEwx6IeeDKH4ytVgUdYCiKEpJE5AiKO5VFpGhIpnFUvFnjeT4qD9CkK1fBABWNL9WnsHQ3M0fRW0hQgV1qYEmlEvtbVgh4pUIPhkHQFj3jATSXM1dttlaAVNVsDRo1jc5FE0Y5DEhSFrMdBCADNUCYpiqCLPBkoXDJbEIa05GKg9CNaDlpLyao9WK61RJUM4yozKhGuw5xWtUdqdjArragA5QbDsXQLjMzEdDKyb0jRGa5s6hluqMwCkXkXJVG89RcnCrwgA */
    createMachine({
        id: 'noteTypes',
        initial: initialState,
        context: {
            noteSchema: initialSchema,
            noteType: initialNoteType,
        },
        states: {
            noShow: {
                states: {
                    notAttended: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.notAttended,
                            },
                        ],
                    },
                    lateCancel: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.lateCancel,
                            },
                        ],
                    },
                },
                on: (_b = {},
                    _b[noteSchemaTransitions.attended] = 'show.unknown',
                    _b[noteSchemaTransitions.notAttended] = 'noShow.notAttended',
                    _b[noteSchemaTransitions.lateCancel] = 'noShow.lateCancel',
                    _b),
            },
            show: {
                initial: 'unknown',
                states: {
                    unknown: {
                        always: [
                            { target: 'intake', cond: 'isIntakeNote' },
                            { target: 'followUp', cond: 'isFollowUpNote' },
                            { target: 'couplesFamilyIntake', cond: 'isCouplesFamilyIntakeNote' },
                            { target: 'couplesFamilyFollowUp', cond: 'isCouplesFamilyFollowUpNote' },
                            { target: 'minorIntake', cond: 'isMinorIntakeNote' },
                            { target: 'minorFollowUp', cond: 'isMinorFollowUpNote' },
                            { target: 'careNavigatorInitial', cond: 'isCareNavigatorInitial' },
                            { target: 'careNavigatorFollowUp', cond: 'isCareNavigatorFollowUp' },
                            { target: 'adultMedManagementIntake', cond: 'isAdultMedManagementIntake' },
                            { target: 'adultMedManagementFollowUp', cond: 'isAdultMedManagementFollowUp' },
                            { target: 'minorMedManagementIntake', cond: 'isMinorMedManagementIntake' },
                            { target: 'minorMedManagementFollowUp', cond: 'isMinorMedManagementFollowUp' },
                        ],
                    },
                    intake: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.intake,
                            },
                        ],
                    },
                    followUp: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.followUp,
                            },
                        ],
                    },
                    couplesFamilyIntake: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.couplesFamilyTherapyIntake,
                            },
                        ],
                    },
                    couplesFamilyFollowUp: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.couplesFamilyTherapyFollowUp,
                            },
                        ],
                    },
                    minorIntake: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.minorTherapyIntake,
                            },
                        ],
                    },
                    minorFollowUp: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.minorTherapyFollowUp,
                            },
                        ],
                    },
                    careNavigatorInitial: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.careNavigatorInitial,
                            },
                        ],
                    },
                    careNavigatorFollowUp: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.careNavigatorFollowUp,
                            },
                        ],
                    },
                    adultMedManagementIntake: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.adultMedManagementIntake,
                            },
                        ],
                    },
                    adultMedManagementFollowUp: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.adultMedManagementFollowUp,
                            },
                        ],
                    },
                    minorMedManagementIntake: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.minorMedManagementIntake,
                            },
                        ],
                    },
                    minorMedManagementFollowUp: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.minorMedManagementFollowUp,
                            },
                        ],
                    },
                },
                on: (_c = {},
                    _c[noteSchemaTransitions.notAttended] = 'noShow.notAttended',
                    _c[noteSchemaTransitions.lateCancel] = 'noShow.lateCancel',
                    _c[noteSchemaTransitions.intake] = 'show.intake',
                    _c[noteSchemaTransitions.followUp] = 'show.followUp',
                    _c[noteSchemaTransitions.couplesFamilyTherapyIntake] = 'show.couplesFamilyIntake',
                    _c[noteSchemaTransitions.couplesFamilyTherapyFollowUp] = 'show.couplesFamilyFollowUp',
                    _c[noteSchemaTransitions.minorTherapyIntake] = 'show.minorIntake',
                    _c[noteSchemaTransitions.minorTherapyFollowUp] = 'show.minorFollowUp',
                    _c[noteSchemaTransitions.careNavigatorInitial] = 'show.careNavigatorInitial',
                    _c[noteSchemaTransitions.careNavigatorFollowUp] = 'show.careNavigatorFollowUp',
                    _c[noteSchemaTransitions.providerUnscheduled] = 'unscheduled.providerUnscheduled',
                    _c[noteSchemaTransitions.careNavigatorUnscheduled] = 'unscheduled.careNavigatorUnscheduled',
                    _c[noteSchemaTransitions.adultMedManagementIntake] = 'show.adultMedManagementIntake',
                    _c[noteSchemaTransitions.adultMedManagementFollowUp] = 'show.adultMedManagementFollowUp',
                    _c[noteSchemaTransitions.minorMedManagementIntake] = 'show.minorMedManagementIntake',
                    _c[noteSchemaTransitions.minorMedManagementFollowUp] = 'show.minorMedManagementFollowUp',
                    _c[noteSchemaTransitions.medManagerUnscheduled] = 'unscheduled.medManagerUnscheduled',
                    _c),
            },
            unscheduled: {
                states: {
                    providerUnscheduled: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.providerUnscheduled,
                            },
                        ],
                    },
                    careNavigatorUnscheduled: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.careNavigatorUnscheduled,
                            },
                        ],
                    },
                    medManagerUnscheduled: {
                        entry: [
                            {
                                type: 'setNoteSchema',
                                data: noteSchema.medManagerUnscheduled,
                            },
                        ],
                    },
                },
            },
        },
        on: {
            SET_NOTE_TYPE: {
                actions: assign({
                    noteType: function (_, event) { return event.data; },
                }),
            },
            SET_NOTE_SCHEMA: {
                actions: assign({
                    noteSchema: function (_, event) { return event.data; },
                }),
            },
        },
    }, {
        actions: {
            setNoteSchema: assign({
                noteSchema: function (_, __, _a) {
                    var action = _a.action;
                    return action.data;
                },
            }),
        },
        guards: {
            isIntakeNote: function (context) { return context.noteType === noteType.adultTherapyIntake; },
            isFollowUpNote: function (context) { return context.noteType === noteType.adultTherapyFollowUp; },
            isCouplesFamilyIntakeNote: function (context) {
                return context.noteType === noteType.couplesFamilyTherapyIntake;
            },
            isCouplesFamilyFollowUpNote: function (context) {
                return context.noteType === noteType.couplesFamilyTherapyFollowUp;
            },
            isMinorIntakeNote: function (context) { return context.noteType === noteType.minorTherapyIntake; },
            isMinorFollowUpNote: function (context) { return context.noteType === noteType.minorTherapyFollowUp; },
            isCareNavigatorInitial: function (context) { return context.noteType === noteType.careNavigatorInitial; },
            isCareNavigatorFollowUp: function (context) { return context.noteType === noteType.careNavigatorFollowUp; },
            isAdultMedManagementIntake: function (context) {
                return context.noteType === noteType.adultMedManagementIntake;
            },
            isAdultMedManagementFollowUp: function (context) {
                return context.noteType === noteType.adultMedManagementFollowUp;
            },
            isMinorMedManagementIntake: function (context) {
                return context.noteType === noteType.minorMedManagementIntake;
            },
            isMinorMedManagementFollowUp: function (context) {
                return context.noteType === noteType.minorMedManagementFollowUp;
            },
        },
    })).current;
    var _g = useMachine(machine), state = _g[0], send = _g[1], service = _g[2];
    // This method is mostly Typescript guff, but works to make the rest of the app properly select the form type
    var selectForm = function (schema) {
        switch (schema) {
            case noteSchema.followUp:
                return {
                    schema: schema,
                    form: ehrForm,
                };
            case noteSchema.intake:
                return {
                    schema: schema,
                    form: ehrForm,
                };
            case noteSchema.notAttended:
                return {
                    schema: schema,
                    form: notAttendedForm,
                };
            case noteSchema.lateCancel:
                return {
                    schema: schema,
                    form: lateCancelForm,
                };
            case noteSchema.couplesFamilyTherapyFollowUp:
                return {
                    schema: schema,
                    form: ehrForm,
                };
            case noteSchema.couplesFamilyTherapyIntake:
                return {
                    schema: schema,
                    form: ehrForm,
                };
            case noteSchema.minorTherapyFollowUp:
                return {
                    schema: schema,
                    form: ehrForm,
                };
            case noteSchema.minorTherapyIntake:
                return {
                    schema: schema,
                    form: ehrForm,
                };
            case noteSchema.providerUnscheduled:
                return {
                    schema: schema,
                    form: unscheduledInteractionForm,
                };
            case noteSchema.careNavigatorUnscheduled:
                return {
                    schema: schema,
                    form: unscheduledCnInteractionForm,
                };
            case noteSchema.careNavigatorInitial:
                return {
                    schema: schema,
                    form: cnAppointmentForm,
                };
            case noteSchema.careNavigatorFollowUp:
                return {
                    schema: schema,
                    form: cnAppointmentForm,
                };
            case noteSchema.adultMedManagementIntake:
                return {
                    schema: schema,
                    form: mmForm,
                };
            case noteSchema.adultMedManagementFollowUp:
                return {
                    schema: schema,
                    form: mmForm,
                };
            case noteSchema.minorMedManagementIntake:
                return {
                    schema: schema,
                    form: mmForm,
                };
            case noteSchema.minorMedManagementFollowUp:
                return {
                    schema: schema,
                    form: mmForm,
                };
            case noteSchema.medManagerUnscheduled:
                return {
                    schema: schema,
                    form: unscheduledMMInteractionForm,
                };
            default:
                return {
                    schema: schema,
                    form: baseForm,
                };
        }
    };
    useEffect(function () {
        var selectedFormSet = selectForm(state.context.noteSchema);
        if ((formSet === null || formSet === void 0 ? void 0 : formSet.form) && formSet.form !== selectedFormSet.form) {
            selectedFormSet.form.reset(__assign(__assign({}, selectedFormSet.form.getValues()), { sessionInfo: __assign(__assign({}, selectedFormSet.form.getValues().sessionInfo), { noteType: formSet.form.getValues('sessionInfo.noteType'), status: formSet.form.getValues('sessionInfo.status') }) }));
        }
        setFormSet(selectedFormSet);
    }, [state]);
    useEffect(function () {
        // Watch noteType and assign to machine context, used to properly transition from noShow schema back to selected
        var noteTypeWatch = formSet.form.watch(function (value, _a) {
            var _b;
            var name = _a.name;
            if (name === 'sessionInfo.noteType') {
                send('SET_NOTE_TYPE', { data: (_b = value.sessionInfo) === null || _b === void 0 ? void 0 : _b.noteType });
            }
        });
        return function () { return noteTypeWatch.unsubscribe(); };
    }, [formSet]);
    var getFormForSchema = function (schema) {
        return selectForm(schema).form;
    };
    var contextState = useMemo(function () { return (__assign(__assign({ state: state, send: send, service: service }, formSet), { noteType: state.context.noteType, setNoteType: function (noteType) { return send('SET_NOTE_TYPE', { data: noteType }); }, setNoteSchema: function (noteSchema) { return send('SET_NOTE_SCHEMA', { data: noteSchema }); }, getFormForSchema: getFormForSchema })); }, [state, send, service, formSet]);
    return _jsx(noteSchemaContext.Provider, __assign({ value: contextState }, { children: children }));
};
export var useNoteSchemaContext = function () { return useContext(noteSchemaContext); };
